import { isNil } from 'lodash';
import { useSelector } from 'react-redux';

import {
  organizationGuidSel,
  unitTypeIdSel,
  youthMemberPersonGuidSel,
} from '@context';
import { validReports } from '@modules/reports/basicReports/constants';
import { NormalizedReportItem } from '@modules/reports/basicReports/duck/utils';
import {
  useGetReportListByOrgQuery,
  useGetReportListByUserQuery,
} from '@modules/rtk/webscript-api';
import { isParentOrYouthMemberSel } from '@modules/shared/duck';

export function useGetBasicReports(overwriteOrgGuid?: string | null) {
  const organizationGuid: string = useSelector(organizationGuidSel);
  const youthMemberPersonGuid = useSelector(
    youthMemberPersonGuidSel,
  ) as unknown as string;
  const unitTypeId = useSelector(unitTypeIdSel);

  const isParentOrYouthMember = useSelector(isParentOrYouthMemberSel);

  const { data: reportDataByOrg, isLoading: isLoadingReportByOrg } =
    useGetReportListByOrgQuery(
      { params: { OrganizationGUID: overwriteOrgGuid || organizationGuid } },
      { skip: isParentOrYouthMember || !organizationGuid },
    );

  const { data: reportDataByUser, isLoading: isLoadingReportByUser } =
    useGetReportListByUserQuery(
      { params: { PersonGUID: youthMemberPersonGuid } },
      {
        skip:
          !isParentOrYouthMember || !organizationGuid || !youthMemberPersonGuid,
      },
    );

  if (isParentOrYouthMember ? isNil(reportDataByUser) : isNil(reportDataByOrg))
    return {
      loading: isLoadingReportByOrg || isLoadingReportByUser,
      reports: [] as NormalizedReportItem[],
      organizationGuid: '',
    };

  const reports = isParentOrYouthMember ? reportDataByUser : reportDataByOrg;

  let filteredReports = reports?.reports ?? [];

  const validReportCodes: string[] =
    validReports[Number(unitTypeId) as keyof typeof validReports];

  if (isNil(overwriteOrgGuid) && validReportCodes) {
    filteredReports = filteredReports.filter(({ reportCode }) =>
      validReportCodes.includes(reportCode),
    );
  }

  return {
    loading: isLoadingReportByOrg || isLoadingReportByUser,
    reports: filteredReports,
    personGuid: youthMemberPersonGuid || '',
    organizationGuid: organizationGuid || '',
  };
}
